// we need to set the template base path were all templates for the
// directives are stored

var MAP_TEMPLATE_BASE_PATH = jQuery('#communeUserData').data('template-folder');
var app = angular.module('Itao.HyperionAtlas', ['Itao.IndicatorMap']);

app.config(function (mapConfigProvider, communeConfigProvider, $compileProvider, $httpProvider) {
  'use strict';
  var communeUserData = jQuery('#communeUserData');
  $compileProvider.debugInfoEnabled(false);
  mapConfigProvider.setConfig('styling', {
    default: {
      weight: 0.5,
      opacity: 1,
      color: 'white',
      dashArray: '0',
      fillOpacity: 0.95,
      fillColor: '#ddd',
      complexColorSet: ['#23bb1e', '#2adb24', '#54e250', '#7fea7b', '#aaf1a7', '#d4f8d3']
    },
    selected: {
      weight: 0,
      color: 'black',
      dashArray: '0',
      fillColor: '#c80b2f'
    },
    hover: {
      weight: 2,
      dashArray: '0',
      fillOpacity: 1
    }
  });
  mapConfigProvider.setConfig("keyLandMapping", {
    labels: [
      {index: '08', key: 'BW', name: 'Baden-Württemberg'},
      {index: '09', key: 'BY', name: 'Bayern'},
      {index: '11', key: 'BE', name: 'Berlin'},
      {index: '12', key: 'BB', name: 'Brandenburg'},
      {index: '04', key: 'HB', name: 'Bremen'},
      {index: '02', key: 'HH', name: 'Hamburg'},
      {index: '06', key: 'HE', name: 'Hessen'},
      {index: '13', key: 'MV', name: 'Mecklenburg-Vorpommern'},
      {index: '03', key: 'NI', name: 'Niedersachsen'},
      {index: '05', key: 'NW', name: 'Nordrhein-Westfalen'},
      {index: '07', key: 'RP', name: 'Rheinland-Pfalz'},
      {index: '10', key: 'SL', name: 'Saarland'},
      {index: '14', key: 'SN', name: 'Sachsen'},
      {index: '15', key: 'ST', name: 'Sachsen-Anhalt'},
      {index: '01', key: 'SH', name: 'Schleswig-Holstein'},
      {index: '16', key: 'TH', name: 'Thüringen'}
    ],
    keys: {
      '01': {key: 'SH'},
      '02': {key: 'HH'},
      '03': {key: 'NI'},
      '04': {key: 'HB'},
      '05': {key: 'NW'},
      '06': {key: 'HE'},
      '07': {key: 'RP'},
      '08': {key: 'BW'},
      '09': {key: 'BY'},
      '10': {key: 'SL'},
      '11': {key: 'BE'},
      '12': {key: 'BB'},
      '13': {key: 'MV'},
      '14': {key: 'SN'},
      '15': {key: 'ST'},
      '16': {key: 'TH'}
    }
  });

  mapConfigProvider.setConfig('templateBasePath', MAP_TEMPLATE_BASE_PATH);
  mapConfigProvider.setConfig('registeredUserMode', angular.isNumber(communeUserData.data('user-id')));
  mapConfigProvider.setConfig('defaultSelectedClassMethod', 'width');
  mapConfigProvider.setConfig('defaultBaseLayer', 'Kein Hintergrund');
  mapConfigProvider.setConfig('widgetExport', {
    cssUrl: location.origin + '/_assets/19afb7c62e901835de82505ec5bff8a5/JavaScript/Hyperion/dist/css/hyperion.css',
    remoteUrl: 'https://export.keck-atlas.de/v1/generateImage'
  });
  mapConfigProvider.setConfig('defaultGridWidgetHeight', angular.isNumber(communeUserData.data('default-grid-widget-height')) ? communeUserData.data('default-grid-widget-height') : 1);
  mapConfigProvider.setConfig('axisMaxValue', angular.isNumber(communeUserData.data('axis-max-value')) ? communeUserData.data('axis-max-value') : null);
  if (angular.isNumber(communeUserData.data('absolute-indicators-decimal-places'))) {
    mapConfigProvider.setConfig('absoluteIndicatorsDecimalPlaces', communeUserData.data('absolute-indicators-decimal-places'));
  }
  if (angular.isNumber(communeUserData.data('relative-indicators-decimal-places'))) {
    mapConfigProvider.setConfig('relativeIndicatorsDecimalPlaces', communeUserData.data('relative-indicators-decimal-places'));
  }
  if (communeUserData.data('available-data-layer-type-uids') != null) {
    var availableDataLayerTypes = ('' + communeUserData.data('available-data-layer-type-uids')).split(',').map( Number );
    mapConfigProvider.setConfig('availableDataLayerTypeUids', availableDataLayerTypes);
    communeConfigProvider.setConfig('availableDataLayerTypeUids', availableDataLayerTypes);
  }
  if (communeUserData.data('red-lines') != null && communeUserData.data('red-lines') !== '') {
    mapConfigProvider.setConfig('redLines', ('' + communeUserData.data('red-lines')).split(';').map(function (value) {
      return +value.replace(',', '.');
    }));
  }
  if (communeUserData.data('years-to-hide') != null && communeUserData.data('years-to-hide') !== '') {
    mapConfigProvider.setConfig('yearsToHide', ('' + communeUserData.data('yearsToHide')).split(';').map(function (value) {
      return value;
    }));
  }

  mapConfigProvider.setConfig('showIndicatorTypeInMapHover', communeUserData.data('show-indicator-type-in-map-hover') === 1);

  communeConfigProvider.setConfig('communeID', communeUserData.data('commune-id'));
  communeConfigProvider.setConfig('userID', communeUserData.data('user-id'));
  communeConfigProvider.setConfig('showEditOptions', communeUserData.data('show-edit-options') === 1);
  communeConfigProvider.setConfig('published', communeUserData.data('published') === 1);
  communeConfigProvider.setConfig('selectInitialIndicator', (communeUserData.data('select-initial-indicator') === 1 && !communeUserData.data('enable-district-report')));
  communeConfigProvider.setConfig('selectInitialIndicatorSet', communeUserData.data('select-initial-indicator-set') === 1);

  var initialIndicatorUids = communeUserData.data('initial-indicator-uids');
  if (initialIndicatorUids == null) {
    initialIndicatorUids = [];
  } else if (angular.isNumber(initialIndicatorUids)) {
    initialIndicatorUids = [initialIndicatorUids];
  } else if (angular.isString(initialIndicatorUids)) {
    initialIndicatorUids = initialIndicatorUids.split(',');
  }
  communeConfigProvider.setConfig('selectInitialIndicatorUids', initialIndicatorUids);
  communeConfigProvider.setConfig('ajaxTargetPid', communeUserData.data('ajax-target-pid'));
  communeConfigProvider.setConfig('fastDownload', communeUserData.data('fast-download-url'));
  $httpProvider.interceptors.push('LoadingInterceptor');
});

// We need to create a controller
// which will communicate with the "webservices" to insert our sample data
app.controller('HyperionAtlasController', function ($scope, $rootScope, $http, $q, $filter, $location, mapConfig, HyperionDataService, IndicatorService, UtilityService, communeConfig, ModalService) {
  'use strict';

  /**
   * Calculates the selected data-layer by getting the last year
   * @param {Object} dataLayers data-layers to search in
   * @returns {Object} the dataLayerObject
   */
  function calculateSelectedDataLayer(dataLayers) {
    var years = Object.keys(dataLayers);

    return dataLayers['' + Math.max.apply(null, years.map(function (n) {
      return parseInt(n, 10);
    }))];
  }

  $scope.formatDecimalToTime = function (number) {
    if (!number) return '';
    var hoursAndMinutes = number.toString().split('.');
    var hours = hoursAndMinutes[0];
    var minutes = hoursAndMinutes[1] ? (hoursAndMinutes[1] / 10 * 6).toString().substr(0, 2) : '00';
    minutes = minutes.length < 2 ? minutes + '0' : minutes;

    return hours + ":" + minutes;
  };

  $scope.selectedIndicators = [];
  $scope.dataLayerIndicators = [];
  $scope.indicatorKeys = [];
  $scope.indicatorSets = [];
  $scope.years = [];
  $scope.districtKeyUidMapping = [];
  $scope.fastDownload = communeConfig.fastDownload;

  $scope.diagramData = {
    indicators: $scope.selectedIndicators,
    yearsToShow: $scope.years,
    indicatorSets: $scope.indicatorSets,
    mouseOverDistrict: null,
    mouseOverYear: null,
    mouseOverFeature: null,
    layers: {},
    colorSets: [],
    selectedDataLayer: {},
    selectedIndicatorSet: $scope.selectedIndicatorSet,
    disabledDataLayers: [],
    noDataDistricts: [],
    selectedDistricts: [],
    disabledDistrictKeys: [],
    selectedChartColorset: null
  };

  $scope.config = {
    'gridContainer': {
      'grids': {}
    },
    'selectedIndicatorIds': [],
    'selectedDistrictKeys': []
  };
  // used for resetting to the last bookmark in the public atlas when textwidgets are used
  $scope.lastLoadedBookmark = {};
  var communeData = jQuery('#communeUserData');

  var indicatorsFromCategory = communeData.data('indicators-from-category');
  var indicatorSetsFromCategory = communeData.data('indicator-sets-from-category');
  var toggleIndicatorsFromCategory = communeData.data('toggle-indicators-from-category');
  var toggleIndicatorSetsFromCategory = communeData.data('toggle-indicator-sets-from-category');
  var enableYearlyMode = communeData.data('yearly-mode');
  var urlParams = $location.search();
  var isDistrictReport = communeData.data('enable-district-report');
  var singleDataDistrict;

  if (urlParams.disabledDistricts) {
    $scope.diagramData.disabledDistrictKeys = urlParams.disabledDistricts.split('_');
  }
  if (urlParams.disabledLayers) {
    $scope.diagramData.disabledDataLayers = urlParams.disabledLayers.split('_');
  }

  var initialDataLayerType = communeData.data('selectedDataLayerTypeUid');
  var category, toggleCategory;
  // Plugin-View or Grid-View

  if ((indicatorsFromCategory || indicatorSetsFromCategory) && (initialDataLayerType || communeConfig.availableDataLayerTypeUids)) {
    if (isDistrictReport) {

      category = [95, 94, 88, 97, 96, 90, 87, 91, 89, 109, 174, 175, 176, 177, 178, 179, 180, 184, 185, 186, 187]; // ToDo: typoscript-config
      // add categories for new indicators...
      singleDataDistrict = -1; // -1 --> do not load initially
    } else {
      category = indicatorsFromCategory ? [indicatorsFromCategory] : [indicatorSetsFromCategory];

      if (toggleIndicatorsFromCategory || toggleIndicatorSetsFromCategory) {
        toggleCategory = toggleIndicatorsFromCategory ? toggleIndicatorsFromCategory : toggleIndicatorSetsFromCategory;
      }
    }

    if (urlParams && urlParams.layerType) {
      initialDataLayerType = urlParams.layerType;
    } else {
      initialDataLayerType = initialDataLayerType ? initialDataLayerType : communeConfig.availableDataLayerTypeUids[0];
    }

    // ToDo: Overview - multiple DataLayerTypes (select DL-Type - give array of selected types to function)
    var dataLayerTypeInitialPromise;
    if (communeConfig.availableDataLayerTypeUids) {
      dataLayerTypeInitialPromise = HyperionDataService.getDataLayerTypes(communeConfig.availableDataLayerTypeUids)
        .then(function (dataLayerTypes) {
          if (!dataLayerTypes) return;
          $scope.dataLayerTypes = dataLayerTypes;
        });
    } else {
      dataLayerTypeInitialPromise = HyperionDataService.getDataLayerTypes([initialDataLayerType])
        .then(function (dataLayerType) {
          if (!dataLayerType) return;
          $scope.dataLayerTypes = dataLayerType;
        });
    }

    var dataLayerInitialPromise = HyperionDataService.getDataLayersForDataLayerType(initialDataLayerType, communeData.data('filter-districts'), toggleCategory ? category.concat([toggleCategory]) : category, singleDataDistrict)
      .then(function (dataLayers) {
        $scope.layers = dataLayers;
      });

    $q.all([dataLayerInitialPromise, dataLayerTypeInitialPromise]).then(function () {
      $scope.dataLayerTypes.forEach(function (dlType) {
        if (dlType.uid == initialDataLayerType) {
          dlType.layers = $scope.layers;
          $scope.selectDataLayerType(dlType, undefined);
        }
      });
    });

    var indicatorSetsInitialPromise = false;
    if (indicatorSetsFromCategory) {
      indicatorSetsInitialPromise = HyperionDataService.getIndicatorSetsFromCategory(indicatorSetsFromCategory, toggleCategory).then(
        function (indicatorSets) {

          $scope.indicatorSets = indicatorSets;
          if (toggleCategory && indicatorSets) {
            $scope.toggleIndicatorSets = [];
            $scope.indicatorSets = $scope.indicatorSets.filter(function (indicatorSet) {
              if (indicatorSet.category == toggleCategory) {
                $scope.toggleIndicatorSets.push(indicatorSet);
                return false;
              } else {
                return true;
              }
            });
          }

          $scope.numberOfIndicatorSets = indicatorSets.length;
          return indicatorSets;
        });
    }

    var indicatorsInitialPromise = HyperionDataService.getIndicatorsFromCategory(indicatorsFromCategory ? indicatorsFromCategory : indicatorSetsFromCategory, toggleCategory)
      .then(function (indicators) {
        $scope.indicators = {};

        if (toggleCategory) {
          $scope.toggleIndicators = {};
          for (var uid in indicators) {
            var indicator = indicators[uid];
            if (indicator.category == toggleCategory) {
              $scope.toggleIndicators[uid] = indicator;
            } else {
              $scope.indicators[uid] = indicator;
            }
          }
        } else {
          $scope.indicators = indicators;
        }
        return indicators;
      });

    /**
     * get colorset in array by uid using filter
     * @param colorsetUid
     * @return {*}
     */
    var getColorsetByUid = function (colorsetUid) {
      return $scope.diagramData.colorSets.filter(function (colorset) {
        return (+colorset.uid) === (+colorsetUid);
      })[0];
    };

    /**
     * get last active layer
     * using for displaying multiple years
     * area- and line-charts need this for legend
     * @param disabledLayers
     * @return {*}
     */
    var getLastActiveLayer = function (disabledLayers) {
      if (!$scope.layers) return;
      var uids = [];
      $scope.years = [];

      for (var layerUid in $scope.layers) {
        var layer = $scope.layers[layerUid];
        //if (disabledLayers.indexOf(layer.year) === -1) { --> always use last last legend
        uids.push(layerUid);
        //}
        if ((!mapConfig.yearsToHide || (mapConfig.yearsToHide && mapConfig.yearsToHide.indexOf(layer.year+'') === -1)) && $scope.selectedIndicator && layer.indicators.indexOf($scope.selectedIndicator.uid) !== -1) {
          $scope.years.push(layer.year);
        }
      }

      return $scope.layers[uids[uids.length - 1]];
    };

    /**
     * sets the last active colorset to diagramData
     * sets override for decimals and max-axis-value from legend
     *
     * @param layer
     */
    var setLastActiveColorset = function (layer) {
      var activeLegend = getActiveLegend(layer, $scope.selectedIndicator, 'chart');

      if(activeLegend && activeLegend.disabledYears) {
        $scope.years = Object.keys($scope.selectedDataLayerType.layers).filter(function(year) { return activeLegend.disabledYears.indexOf(parseInt(year)) === -1; });
      } else if(mapConfig.yearsToHide) {
        $scope.years = Object.keys($scope.selectedDataLayerType.layers).filter(function(year) { return mapConfig.yearsToHide.indexOf(year) === -1; });
      } else {
        $scope.years = Object.keys($scope.selectedDataLayerType.layers);
      }

      $scope.layers = {};
      $scope.years.forEach(function(year){
        $scope.layers[year] = $scope.selectedDataLayerType.layers[year];
      });

      if (activeLegend && +activeLegend.colorSet) {
        $scope.activeLegend = activeLegend;
        $scope.diagramData.selectedChartColorset = getColorsetByUid(activeLegend.colorSet);
        $scope.diagramData.decimalsOverride = activeLegend.decimals;
        $scope.diagramData.maxAxisValueOverride = activeLegend.maxAxisValue;
      } else if (angular.isNumber(colorsetUid)) {
        $scope.activeLegend = undefined;
        $scope.diagramData.selectedChartColorset = getColorsetByUid(colorsetUid);
        delete $scope.diagramData.decimalsOverride;
        delete $scope.diagramData.maxAxisValueOverride;
      } else {
        $scope.activeLegend = undefined;
        delete $scope.diagramData.decimalsOverride;
        delete $scope.diagramData.maxAxisValueOverride;
      }
    };

    /**
     * set active legend
     *
     * @param disabledDataLayers
     */
    var setActiveLegend = function (disabledDataLayers) {
      $scope.lastActiveLayer = getLastActiveLayer(disabledDataLayers);
      if ($scope.lastActiveLayer) {
        setLastActiveColorset($scope.lastActiveLayer);

        if (enableYearlyMode) {
          $scope.diagramData.enableYearlyMode = true;
          $scope.diagramData.selectedDistrictKey = $scope.lastActiveLayer.districts[Object.keys($scope.lastActiveLayer.districts)[0]].key;
        }
      }
    };

    $scope.toggle = false;

    /**
     * toggle indicators to show
     */
    $scope.toggleIndicatorsToShow = function () {
      if ($scope.toggle) {
        setScopeIndicators($scope.indicators, $scope.indicatorSets);
      } else {
        setScopeIndicators($scope.toggleIndicators, $scope.toggleIndicatorSets);
      }

      $scope.toggle = !$scope.toggle;
      setSubtitle();
    };

    var colorsetUid = communeData.data('selected-colorset-uid');
    //var colorSetInitialPromise = HyperionDataService.getColorSets(colorsetUid)
    var colorSetInitialPromise = HyperionDataService.getColorSets()
      .then(function (colorSets) {
        $scope.diagramData.colorSets = colorSets;
        return colorSets;
      });

    $q.all([dataLayerInitialPromise, indicatorsInitialPromise, dataLayerTypeInitialPromise, colorSetInitialPromise]).then(function () {
      var initialWidget = communeData.data('initial-widget');
      if (initialWidget) {
        $rootScope.$broadcast('createNewWidget', {
          type: initialWidget
        });
      } else {
        $rootScope.$broadcast('createNewWidget', {
          type: 'map'
        });
      }
    });

    $scope.hasToggleData = function () {
      if (!$scope.toggleIndicators || !Object.keys($scope.toggleIndicators).length || !$scope.selectedDataLayer) return false;

      for (var uid in IndicatorService.filterIndicatorsByUids($scope.toggleIndicators, $scope.selectedDataLayer.indicators, [])) {
        if ($scope.toggleIndicators[uid].hasShapeData) {
          return true;
        }
      }

      return false;
    };

    var setScopeIndicators = function (indicators, indicatorSets) {
      var indicatorUids = $scope.selectedDataLayer.indicators;

      $scope.dataLayerIndicators = IndicatorService.filterIndicatorsByUids(indicators, indicatorUids, []);
      $scope.selectAbleIndicators = IndicatorService.filterOutSetIndicators($scope.dataLayerIndicators);
      $scope.selectAbleIndicatorSets = IndicatorService.findIndicatorSetsInIndicators($scope.dataLayerIndicators, indicatorSets);
      $scope.diagramData.selectAbleIndicatorSets = $scope.selectAbleIndicatorSets;

      // find first indicator after sorting
      var selectableIndicatorsArray = Object.keys($scope.selectAbleIndicators)
        .map(function (uid) {
          return $scope.selectAbleIndicators[uid];
        })
        .sort(function (a, b) {
          var sortingValueA = 0;
          var sortingValueB = 0;

          if (a.isDefault && $scope.indicatorSets != null) {
            sortingValueA = getIndicatorSetSortingByDefaultIndicatorUid(a.uid);
          } else {
            sortingValueA = a.sorting;
          }

          if (b.isDefault && $scope.indicatorSets != null) {
            sortingValueB = getIndicatorSetSortingByDefaultIndicatorUid(b.uid);
          } else {
            sortingValueB = b.sorting;
          }

          return sortingValueA - sortingValueB;
        });

      var firstIndicatorUid = null;
      if ($scope.selectAbleIndicatorSets && $scope.selectAbleIndicatorSets[0] && $scope.selectAbleIndicatorSets[0].indicators[0]) {
        firstIndicatorUid = $scope.selectAbleIndicatorSets[0].indicators.filter(function (indicator) {
          return indicator.isDefault;
        })[0].uid;
      } else if (selectableIndicatorsArray.length > 0) {
        firstIndicatorUid = selectableIndicatorsArray[0].uid;
      }

      // deselect all
      $scope.deselectAllIndicators();

      if (communeConfig.selectInitialIndicatorUids.length > 0) {
        if (urlParams.indicator) {
          $scope.selectIndicator(urlParams.indicator);
          $scope.selectedIndicator = $scope.selectAbleIndicators[urlParams.indicator];
        } else {
          angular.forEach(communeConfig.selectInitialIndicatorUids, function (uid) {
            if ($scope.selectAbleIndicators.hasOwnProperty(uid)) {
              $scope.selectIndicator($scope.selectAbleIndicators[uid]);
              $scope.selectedIndicator = $scope.selectAbleIndicators[uid];
            }
          });
        }
      } else if (firstIndicatorUid && communeConfig.selectInitialIndicator) {
        if (urlParams.indicator) {
          $scope.selectIndicator(urlParams.indicator);
          $scope.selectedIndicator = $scope.selectAbleIndicators[urlParams.indicator];
        } else {
          $scope.selectIndicator($scope.selectAbleIndicators[firstIndicatorUid]);
          $scope.selectedIndicator = $scope.selectAbleIndicators[firstIndicatorUid];
        }
      } else if (communeConfig.selectInitialIndicatorSet && $scope.indicatorSets.length > 0) {
        if (urlParams.indicatorSet) {
          var indicatorSetToSelect = $scope.selectAbleIndicatorSets.reduce(function (acc, curr) {
            if (curr.uid == urlParams.indicatorSet) return curr;
          });
          $scope.selectIndicatorSet(indicatorSetToSelect);
          $scope.selectedIndicatorSet = indicatorSetToSelect;
        } else {
          $scope.selectIndicatorSet($scope.selectAbleIndicatorSets[0]);
          $scope.selectedIndicatorSet = $scope.selectAbleIndicatorSets[0];
        }
      }
    };

    $q.all([indicatorsInitialPromise, indicatorSetsInitialPromise, dataLayerInitialPromise, colorSetInitialPromise]).then(function () {
      $scope.indicatorSets.forEach(function (indicatorSet) {
        indicatorSet.addIndicators($scope.indicators);
        indicatorSet.populateColorSets($scope.diagramData.colorSets);
      });

      if ($scope.toggleIndicatorSets) {
        $scope.toggleIndicatorSets.forEach(function (indicatorSet) {
          indicatorSet.addIndicators($scope.toggleIndicators);
          indicatorSet.populateColorSets($scope.diagramData.colorSets);
        });
      }

      $scope.diagramData.indicatorSets = $scope.indicatorSets;

      if ($scope.selectedDataLayer && $scope.indicators && !isDistrictReport) {
        setScopeIndicators($scope.indicators, $scope.indicatorSets);

      } else {
        if (!$scope.selectedDataLayer) console.warn("No DataLayer selected");
        if (!$scope.indicators) console.warn("No indicators loaded");
      }
    });

  }

  function getIndicatorSetSortingByDefaultIndicatorUid(uid) {
    var indicatorSetSorting = 0;
    $scope.indicatorSets.forEach(function (indicatorSet) {
      if (indicatorSet.defaultIndicator && indicatorSet.defaultIndicator.uid === uid) {
        indicatorSetSorting = indicatorSet.sorting;
      }
    });
    return indicatorSetSorting;
  }

  function setSubtitle() {
    if (!$scope.selectedIndicatorSet && !$scope.selectedIndicator) return;
    var hasToggleData = $scope.hasToggleData();
    var indicatorName = $scope.selectedIndicatorSet ? $scope.selectedIndicatorSet.name : $scope.selectedIndicator.name;
    var activeLegend = getActiveLegend($scope.selectedDataLayer, $scope.selectedIndicator);

    if (activeLegend && activeLegend.indicatorSubtitle) {
      $scope.subtitle = activeLegend.indicatorSubtitle;
      return;
    }

    // begin: quick & dirty for indicators 320 & 321 & 667
    // TODO: replace this subtitle with new legend-function
    if ($scope.selectedIndicator && ($scope.selectedIndicator.uid == 320 || $scope.selectedIndicator.uid == 321) && !hasToggleData) {
      $scope.subtitle = 'KiTas ohne Horte';
      return;
    }

    // TODO: replace this subtitle with new legend-function
    if ($scope.selectedIndicator && $scope.selectedIndicator.uid == 667) {
      $scope.subtitle = 'KiTas mit Horten';
      return;
    }
    // end: quick & dirty for indicators 320 & 321 & 667

    if ($scope.toggle && hasToggleData) {
      $scope.subtitle = Object.keys($scope.selectAbleIndicators).length > 1 ? indicatorName + ', KiTas ohne Horte' : 'KiTas ohne Horte';
    } else if (!$scope.toggle && $scope.toggleIndicators) {
      $scope.subtitle = Object.keys($scope.selectAbleIndicators).length > 1 ? indicatorName + ', KiTas mit Horten' : 'KiTas mit Horten';
    } else {
      $scope.subtitle = Object.keys($scope.selectAbleIndicators).length > 1 ? indicatorName : '';
    }
  }

  /**
   * returns map- or chart-legend from data-layer and indicator
   * @param dataLayer
   * @param indicator
   * @param type
   * @return {null|*}
   */
  function getActiveLegend(dataLayer, indicator, type) {
    if (!type) {
      type = 'map';
    }

    if (dataLayer && dataLayer.legend && indicator && dataLayer.legend[indicator.uid] && dataLayer.legend[indicator.uid][type]) {
      return dataLayer.legend[indicator.uid].chart || dataLayer.legend[indicator.uid][type];
    }

    return null;
  }

  /* eslint-enable no-unused-vars */
  /**
   * Sets the current dataLayer
   * @param {object} dataLayer the datalayer to select
   */
  $scope.selectDataLayer = function (dataLayer) {
    if (!dataLayer) return;
    $scope.selectedDataLayer = dataLayer;
    $scope.config.selectedDataLayerYear = dataLayer.year;
    $scope.diagramData.selectedDataLayer = dataLayer;

    if (isDistrictReport) {
      initializeDistricts(dataLayer);
      if (dataLayer.year > 2018 && $scope.activeReportTab === 'all') {
        $scope.activeReportTab = 'kita';
        $scope.hideLower2018Report = true;
      } else if (dataLayer.year <= 2018) {
        $scope.activeReportTab = 'all';
        $scope.hideLower2018Report = false;
      }
      return;
    }

    var indicatorUids = $scope.selectedDataLayer.indicators;

    if ($scope.toggle && $scope.hasToggleData()) {
      $scope.dataLayerIndicators = IndicatorService.filterIndicatorsByUids($scope.toggleIndicators, indicatorUids);
      $scope.selectAbleIndicatorSets = $scope.diagramData.selectAbleIndicatorSets = IndicatorService.findIndicatorSetsInIndicators($scope.dataLayerIndicators, $scope.toggleIndicatorSets);
    } else {
      $scope.dataLayerIndicators = IndicatorService.filterIndicatorsByUids($scope.indicators, indicatorUids);
      $scope.selectAbleIndicatorSets = $scope.diagramData.selectAbleIndicatorSets = IndicatorService.findIndicatorSetsInIndicators($scope.dataLayerIndicators, $scope.indicatorSets);
    }

    $scope.selectAbleIndicators = $scope.diagramData.selectAbleIndicators = IndicatorService.filterOutSetIndicators($scope.dataLayerIndicators);

    if ((!indicatorSetsFromCategory && indicatorsFromCategory && angular.equals($scope.selectAbleIndicators, {})) ||
      (!indicatorsFromCategory && indicatorSetsFromCategory && !$scope.selectAbleIndicatorSets.length) ||
      (indicatorsFromCategory && indicatorSetsFromCategory && !$scope.selectAbleIndicatorSets.length && angular.equals($scope.selectAbleIndicators, {}))) {
      var years = Object.keys($scope.layers);
      var index = years.indexOf($scope.selectedDataLayer.year);
      if ($scope.selectedDataLayerType.layers) {
        delete $scope.selectedDataLayerType.layers[$scope.selectedDataLayer.year];
        delete $scope.layers[$scope.selectedDataLayer.year];
      }
      $scope.selectDataLayer($scope.layers[years[index - 1]]);
    }

    if (communeConfig.selectInitialIndicator && $scope.selectAbleIndicators && $scope.selectAbleIndicators != {}) {
      if (!$scope.selectedIndicator || !$scope.selectAbleIndicators[$scope.selectedIndicator.uid]) {
        var firstIndicatorUid = Object.keys($scope.selectAbleIndicators)[0];
        $scope.deselectAllIndicators();
        $scope.selectIndicator($scope.selectAbleIndicators[firstIndicatorUid]);
        $scope.selectedIndicator = $scope.selectAbleIndicators[firstIndicatorUid];
      } else {
        // if another DL-Type is selected - reselect indicator
        $scope.deselectAllIndicators();
        $scope.selectIndicator($scope.selectedIndicator);
      }
    } else if (communeConfig.selectInitialIndicatorSet && $scope.indicatorSets.length > 0) {
      if ($scope.selectAbleIndicatorSets.indexOf($scope.selectedIndicatorSet) === -1) {
        $scope.deselectAllIndicators();
        $scope.selectIndicatorSet($scope.selectAbleIndicatorSets[0]);
        $scope.selectedIndicatorSet = $scope.selectAbleIndicatorSets[0];
      }
    }

    initializeDistricts(dataLayer);
    setSubtitle();

    if (urlParams.blToZoom) {
      $scope.blToZoom = urlParams.blToZoom;
    }
  };

  function initializeDistricts(dataLayer) {
    if (angular.isObject(dataLayer) && dataLayer.hasOwnProperty('districts') && !isDistrictReport) {
      $scope.diagramData.selectedDistricts = [];
      $scope.diagramData.unselectedDistricts = [];
      // get all keys available in the layer
      var layerKeys = [];
      for (var districtUid in dataLayer.districts) {
        var districtKey = dataLayer.districts[districtUid].key;
        layerKeys.push(districtKey);
        $scope.districtKeyUidMapping[districtKey] = districtUid;
      }

      // remove selected keys that are not available
      var filteredSelectedKeys = $scope.config.selectedDistrictKeys.filter(function (key) {
        return layerKeys.indexOf(key) !== -1;
      });

      if (urlParams.selectedDistrict) {
        $scope.config.selectedDistrictKeys[0] = urlParams.selectedDistrict;
      } else {
        $scope.config.selectedDistrictKeys = filteredSelectedKeys;
      }
    } else if ($scope.config.selectedDistrictKeys[0]) {
      $scope.diagramData.selectedDistricts = [];
      $scope.diagramData.unselectedDistricts = [];
      if (urlParams.selectedDistrict) {
        $scope.config.selectedDistrictKeys[0] = urlParams.selectedDistrict;
      }
    }
    updateDistrictSelection($scope.config.selectedDistrictKeys);
  }

  var updateDistrictSelection = function (newSelectedDistrictKeys) {
    $scope.diagramData.selectedDistricts = [];
    $scope.diagramData.unselectedDistricts = [];
    for (var districtUid in $scope.selectedDataLayer.districts) {
      var districtKey = $scope.selectedDataLayer.districts[districtUid].key;
      if (newSelectedDistrictKeys.indexOf(districtKey) !== -1) {
        $scope.diagramData.selectedDistricts.push(angular.copy($scope.selectedDataLayer.districts[districtUid]));
      } else {
        $scope.diagramData.unselectedDistricts.push(angular.copy($scope.selectedDataLayer.districts[districtUid]));
      }
    }
  };

  $scope.toggleAtlasControl = function ($event, controlId) {
    var control = jQuery('#' + controlId);
    control.toggleClass('active');
    jQuery('.app-menu').find('.' + controlId).toggleClass('active');

    if (jQuery('.app-menu a.active').length > 0) {
      jQuery('.atlas-control-right').addClass('active');
    } else {
      jQuery('.atlas-control-right').removeClass('active');
    }
  };

  $scope.toggleControlContent = function ($event) {
    var heading = jQuery($event.currentTarget).closest('.atlas-control-group-heading');
    heading.next('.atlas-control-group-content').toggleClass('active');
    heading.toggleClass('active');
  };

  /**
   * Sets the current dataLayerType and fetches the according dataLayers
   * @param {DataLayerType} dataLayerType the data-layer-type to select
   * @param {int} singleDataDistrict
   * @returns {Promise}
   */
  $scope.selectDataLayerType = function (dataLayerType, singleDataDistrict) {
    if(isDistrictReport && !singleDataDistrict) {
      singleDataDistrict = -1;
    }

    if (!dataLayerType || ($scope.selectedDataLayerType && dataLayerType.uid === $scope.selectedDataLayerType.uid && !singleDataDistrict)) {
      return $q.when(null);
    }
    // remove all indicators on switch
    $scope.deselectAllIndicators();

    $scope.selectedDataLayerType = dataLayerType;
    $scope.config.selectedDataLayerTypeId = dataLayerType.uid;
    $scope.config.selectedDataLayerTypeName = dataLayerType.name;

    if (dataLayerType.layers && !singleDataDistrict) {
      $scope.diagramData.layers = angular.copy(dataLayerType.layers);
      $scope.layers = $scope.diagramData.layers;

      if (urlParams.year) {
        $scope.selectDataLayer($scope.layers[urlParams.year]);
      } else {
        $scope.selectDataLayer(calculateSelectedDataLayer($scope.layers));
      }
      $scope.config.selectedDataLayerYear = $scope.selectedDataLayer.year;
      $scope.diagramData.selectedDataLayer = $scope.selectedDataLayer;
    } else {
      return HyperionDataService.getDataLayersForDataLayerType(dataLayerType.uid, communeData.data('filter-districts'), toggleCategory ? category.concat([toggleCategory]) : category, singleDataDistrict)
        .then(function (dataLayers) {
          dataLayerType.layers = dataLayers;
          $scope.layers = dataLayers;
          $scope.diagramData.layers = $scope.layers;
          if (urlParams.year) {
            $scope.selectDataLayer(dataLayers[urlParams.year]);
          } else {
            $scope.selectDataLayer(calculateSelectedDataLayer(dataLayers));
          }
          $scope.config.selectedDataLayerYear = $scope.selectedDataLayer.year;
          $scope.diagramData.selectedDataLayer = $scope.selectedDataLayer;
        });
    }
  };

  function getUid(item) {
    return item.uid;
  }

  $scope.selectIndicatorSet = function (indicatorSet) {
    if (!indicatorSet) {
      console.warn("selectIndicatorSet: indicatorSet is undefined");
      return;
    }

    var defaultIndicator = indicatorSet.getDefaultIndicator();

    $scope.selectedIndicatorSet = indicatorSet;
    $scope.diagramData.selectedIndicatorSet = indicatorSet;
    $scope.selectIndicator(defaultIndicator);
  };

  $scope.selectSingleDistrict = function (district) {
    $scope.config.selectedDistrictKeys = [];
    $scope.selectDistrict(district);
  };

  /**
   * Selects another district
   * @param {string} district the indicator to set
   */
  $scope.selectDistrict = function (district) {
    if ($scope.config.selectedDistrictKeys.indexOf(district) === -1) {
      $scope.config.selectedDistrictKeys.push(district);
    }
    selectDistrictFromKeys($scope.config.selectedDistrictKeys);

    if(isDistrictReport && district) {
      $scope.selectDataLayerType($scope.selectedDataLayerType, district);
    }
  };

  $scope.deselectDistrict = function (districtKey) {
    var index = $scope.config.selectedDistrictKeys.indexOf(districtKey);
    if (index !== -1) {
      $scope.config.selectedDistrictKeys.splice(index, 1);
    }
    selectDistrictFromKeys($scope.config.selectedDistrictKeys);
  };

  function selectDistrictFromKeys(newSelectedDistrictKeys) {
    if (angular.isArray(newSelectedDistrictKeys) && angular.isObject($scope.selectedDataLayer)) {
      updateDistrictSelection(newSelectedDistrictKeys);
    }
  }

  /**
   * Sets the current indicator and build the default scale
   * @param {Indicator} indicator the indicator to set
   */
  $scope.selectIndicator = function (indicator) {
    if (!indicator) return;

    if ($scope.toggle && $scope.hasToggleData()) {
    } else if ($scope.toggle && $scope.toggleIndicators) {
      $scope.toggle = false;
    }

    if (indicator.class === 'indicator') {
      if ($scope.selectedIndicators.map(getUid).indexOf(indicator.uid) < 0) {

        $scope.selectedIndicators.push(indicator);
        if ($scope.selectedIndicators.length === 1) {
          $scope.selectedIndicator = indicator;
        }
        $scope.config.selectedIndicatorIds.push(indicator.uid);
      }
    } else if (indicator.class === 'indicator-type') {
      if ($scope.selectedIndicators.map(getUid).indexOf(indicator.defaultIndicator.uid) < 0) {
        $scope.selectedIndicators.push(indicator.defaultIndicator);
        $scope.config.selectedIndicatorIds.push(indicator.defaultIndicator.uid);
      }
    }

    setSubtitle();
    setActiveLegend($scope.diagramData.disabledDataLayers);
  };

  /**
   * Deselect an indicator
   * @param {Indicator} indicator the indicator to deselect
   */
  $scope.deselectIndicator = function (indicator) {
    var indicatorIndex = $scope.selectedIndicators.map(getUid).indexOf(indicator.uid);
    $scope.selectedIndicators.splice(indicatorIndex, 1);

    var indicatorIdIndex = $scope.config.selectedIndicatorIds.indexOf(indicator.uid);
    $scope.config.selectedIndicatorIds.splice(indicatorIdIndex, 1);

    if (!$scope.selectedIndicators.length) {
      $scope.config.selectedIndicatorUid = null;
    } else if (indicatorIndex === 0) {
      $scope.config.selectedIndicatorUid = $scope.selectedIndicators[0].uid;
    }
  };

  /**
   * Deselect all indicators
   */
  $scope.deselectAllIndicators = function () {
    if (angular.isArray($scope.selectedIndicators)) {
      $scope.selectedIndicators.splice(0, $scope.selectedIndicators.length);
    }
    if (angular.isArray($scope.config.selectedIndicatorIds)) {
      $scope.config.selectedIndicatorIds.splice(0, $scope.config.selectedIndicatorIds.length);
    }
  };
  // watch disabled layers --> get last active layer --> get last active colorset --> set to active chart color set - fallback plugin colorset

  $scope.$watchCollection('diagramData.disabledDataLayers', function (newDisabledDataLayers) {
    setActiveLegend(newDisabledDataLayers);
  });


  $scope.buildShareLink = function () {
    var link = window.location.href;
    link = link.split('#')[0]; // deletes old params

    link += "#?layerType=" + $scope.selectedDataLayer.data_layer_type;
    link += "&year=" + $scope.selectedDataLayer.year;
    if ($scope.selectedIndicatorSet) {
      link += "&indicatorSet=" + $scope.selectedIndicatorSet.uid;
    } else if ($scope.selectedIndicator) {
      link += "&indicator=" + $scope.selectedIndicator.uid;
    }

    if ($scope.diagramData.disabledDistrictKeys.length) {
      link += "&disabledDistricts=" + $scope.diagramData.disabledDistrictKeys.join('_');
    }
    if ($scope.diagramData.disabledDataLayers.length) {
      link += "&disabledLayers=" + $scope.diagramData.disabledDataLayers.join('_');
    }

    if ($scope.diagramData.selectedDistricts && $scope.diagramData.selectedDistricts[0]) {
      link += "&selectedDistrict=" + $scope.diagramData.selectedDistricts[0].key;
    }

    if ($scope.blToZoom) {
      link += "&blToZoom=" + $scope.blToZoom;
    }

    ModalService.createCustomModal({
      link: link
    }, {
      templateUrl: MAP_TEMPLATE_BASE_PATH + 'modals/shareLink.html',
      controller: 'ShareLinkModalController'
    })
      .result
      .then(function (bookmarkData) {
      })
      .catch(function (dismissReason) {
        console.log(dismissReason);
      });
  };
});

app.filter('highlight', function ($sce) {
  'use strict';
  return function (text, phrase) {
    if (phrase) {
      text = text.replace(new RegExp('(' + phrase + ')', 'gi'),
        '<span class="highlighted">$1</span>');
    }
    return $sce.trustAsHtml(text);
  };
});

app.filter('numKeys', function () {
  return function (object) {
    if (!object) return;
    var keys = Object.keys(object);
    return keys.length;
  };
});
